import { defineNuxtPlugin } from '#app/nuxt'
import { LazyArticleContact, LazyArticleCookies, LazyArticleCookiesAnalytical, LazyArticleCookiesNecessary, LazyArticleCookiesWhatAre, LazyArticleHome, LazyArticlePrivacy, LazyIconChevronRight, LazyIconClose, LazyIconEdit, LazyIconLocation } from '#components'
const lazyGlobalComponents = [
  ["ArticleContact", LazyArticleContact],
["ArticleCookies", LazyArticleCookies],
["ArticleCookiesAnalytical", LazyArticleCookiesAnalytical],
["ArticleCookiesNecessary", LazyArticleCookiesNecessary],
["ArticleCookiesWhatAre", LazyArticleCookiesWhatAre],
["ArticleHome", LazyArticleHome],
["ArticlePrivacy", LazyArticlePrivacy],
["IconChevronRight", LazyIconChevronRight],
["IconClose", LazyIconClose],
["IconEdit", LazyIconEdit],
["IconLocation", LazyIconLocation],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
